const settings = {
  
  wcfRoot: `${getBase()}/workflow/rest-service`,
  coreRoot: `${getBase()}/core-service`,
  instanceRoot: `${getBase()}/api/instance`,
  nodeRoot:  `${getBase()}/workflow/napi`,
  apiRoot: `${getBase()}/workflow/api/v2.0`,
  wsRoot: `${getBase()}`,
  microServiceRoot: `${getBase()}/api`,
  tenant: sessionStorage.getItem('tenant'), // to be scraped from url or entered by user
  frontEndRoot: {
    angular: {
      full: '/workflow/angular',
      partial: '/angular'
    }
  }
};



function getBase() {
  if (process.env.NODE_ENV == 'test')
    return 'http://localhost:3508';
  else
    return '';
}

export default settings;
